// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"d5fc5995","126":"ac8b2b88","275":"3c5cc3ae","346":"ce80cade","512":"4e9fb90c","552":"d225b51b","745":"ff20e338","777":"291a85ce"}[chunkId] + ".chunk.js";
};